$(function () {
    if($('.page--trade').length){
        var href = location.href;
        $('.trade-home-menu-link-container a').each(function(){
            var pageHref = $(this).attr('href');
            pageHref = pageHref.substring(0, pageHref.length - 1);
            if(href.includes(pageHref)){
                $(this).addClass('active');
            }
        });
    }
});